import { QuestionnaireService } from '@/services/QuestionnaireService';

const state = {
  questionnaires: [],
  currentQuestionnaire: null
};

const mutations = {
  SET_QUESTIONNAIRES(state, payload) {
    state.questionnaires = payload;
  },
  ADD_QUESTIONNAIRE(state, payload) {
    state.questionnaires.push(payload);
  },
  SET_CURRENT_QUESTIONNAIRE(state, payload) {
    state.currentQuestionnaire = payload;
  },
  UPDATE_QUESTIONNAIRE(state, updated) {
    const index = state.questionnaires.findIndex(q => q.id === updated.id);
    if (index !== -1) state.questionnaires.splice(index, 1, updated);
  },
  DELETE_QUESTIONNAIRE(state, id) {
    state.questionnaires = state.questionnaires.filter(q => q.id !== id);
  }
};

const actions = {
  async fetchQuestionnaires({ commit }) {
    const res = await QuestionnaireService.getAll();
    commit('SET_QUESTIONNAIRES', res.data);
  },

  async fetchQuestionnairesByRevision({ commit }, revisionId) {
    const res = await QuestionnaireService.getAllByRevision(revisionId);
    commit('SET_QUESTIONNAIRES', res.data);
  },

  async fetchQuestionnaireById({ commit }, id) {
    const res = await QuestionnaireService.show(id);
    commit('SET_CURRENT_QUESTIONNAIRE', res.data);
    return res;
  },

  async createQuestionnaire({ commit }, questionnaireData) {
    const res = await QuestionnaireService.create(questionnaireData);
    commit('ADD_QUESTIONNAIRE', res.data);
    return res;
  },

  async updateQuestionnaire({ commit }, { id, data }) {
    const res = await QuestionnaireService.update(id, data);
    commit('UPDATE_QUESTIONNAIRE', res.data);
    return res;
  },

  async deleteQuestionnaire({ commit }, id) {
    await QuestionnaireService.delete(id);
    commit('DELETE_QUESTIONNAIRE', id);
  }
};

const getters = {
  questionnaires: state => state.questionnaires,
  currentQuestionnaire: state => state.currentQuestionnaire
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
